import React from 'react';

const MinusIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="50" cy="50" r="50" fill="#C52222" />
    <path
      d="M25 50C25 48.6193 26.1193 47.5 27.5 47.5H72.5C73.8807 47.5 75 48.6193 75 50C75 51.3807 73.8807 52.5 72.5 52.5H27.5C26.1193 52.5 25 51.3807 25 50Z"
      fill="white"
    />
  </svg>
);

export default MinusIcon;
